module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_8003.7cf77db0.png";